import React, {  useEffect, useState } from 'react'
import Loadersspinners from './Loaders/LoadersSpinners';
import axios from 'axios';
import {useSelector, useDispatch} from 'react-redux' 
import { cartItem } from '../features/cartdata';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import Modal from './modals/Modals';
import ClearCartModal from './modals/ClearCartModal';
import { Baseurl } from '../constants/env';
import Button from 'react-bootstrap/esm/Button';
import { useSnackbar } from 'notistack';
import { setuserdata } from '../features/auth'
import Tempfooter from './Tempfooter';

const Cart = () => {
  const dispatch = useDispatch();
   const{enqueueSnackbar} = useSnackbar();
  const [Loading, setLoading] = useState(false);
  const [totalprice,setTotalprice] = useState();
  const [totallen,setTotallen] = useState();
  const [productsarray,setProductsarray]= useState([]);
  const [appliedcode,setAppliedcode]= useState([]);
  const [remove,setRemove] = useState();
  const [tax,setTax] = useState();

  //const [data,setData]= useState([]);
  const [code,setCode]= useState([])

  const {totalcartitem} = useSelector((state)=>state.cart) 
  const {userid, userdata, userlogedin} = useSelector((state)=>state.auth) 
  useEffect(()=>{

    getdata()
  },[remove, totalprice])

       async function addWish(itemid){
        if(!userlogedin){
          return enqueueSnackbar('Login to add wishlist',{variant:'error'})
        }
        let data = {
         userid,
         productId:itemid
       }
      await axios.patch(`${Baseurl}/wishlist`,data ,{ withCredentials: true }).then((resp)=>{
      // dispatch(cartItem(resp.data.cartlength));          
      // setcartResp(resp);
       if(resp.status === 200){
         dispatch(setuserdata(true))
         dispatch(setuserdata(resp.data.userdata))
         localStorage.setItem('userdata',resp.data.cartlength)
         return enqueueSnackbar('Product removed from wishlist',{variant:'success'})
       }
       if(resp.status === 201){
        dispatch(setuserdata(true))
        dispatch(setuserdata(resp.data.userdata))
        localStorage.setItem('userdata',resp.data.cartlength)
        return enqueueSnackbar('Product added to wishlist',{variant:'success'})
      }
       }).catch((err)=>{
       console.log(err);
       enqueueSnackbar(err,{variant:'error'})
      });
     }

  const applyCode = async () => {
    let params = {
    code,
    price:totalprice - tax,
    userid
    }
    let data = await axios.post(`${Baseurl}/applycode`,params)
    setTax( parseInt(data.data.discounted * 0.025) )
    const taxes = data.data.discounted * 0.025
    setTotalprice(parseInt(data.data.discounted + taxes));
  }
 async function getdata(){
  setLoading(true);
  await axios(`${Baseurl}/cart?id=${userid}`,{ withCredentials: true })
   .then((resp) => {
    setAppliedcode(resp?.data?.applliedCode)
     setTotallen(resp.data.cartlength);
     setTax( parseInt(resp.data.totalamount * 0.025) )
     const taxes = resp.data.totalamount * 0.025
     setTotalprice(parseInt(resp.data.totalamount + taxes));
     setProductsarray(resp.data.products);
     dispatch(cartItem(resp.data.cartlength));
     localStorage.setItem('cart',resp.data.cartlength)
     setLoading(false);
   }).catch((e)=>{
     console.log(e.mesaage);
     setLoading(false);
   });
 
  }
 
  return (
   
    <div>

<main className='main'>
<section className='section-inner-page'>
<div className="container">
      <div className="row">
        {/* Cart Section */}
        <div className="col-lg-8">

          <div className='widget-block'>
          {
            productsarray?.map((item,idx) => (
              <div key={idx} className="d-flex align-items-center border-bottom py-3">
              <img
                src={`${Baseurl}/view/imageupload/${item?.img}`}
                alt="Product"
                className="me-3 w-25 h-25"
              />
              <div className="flex-grow-1">
                <strong>{item?.name}</strong>
                <br />
                <small>
                Type {item?.type}
                  <br />
                Brand {item?.brand}
                </small>
                <div className="mt-2">
                  <button className="btn btn-danger btn-sm me-2"><Modal itemid={item._id} setremove={setRemove} /></button>
                  <button className="btn btn-warning btn-sm text-white" onClick={() => addWish(item?._id)}>
                    { userdata?.wishlist?.includes(item?._id) ? 'Remove From Wishlist' : 'Add to wishlist' }
                  </button>
                </div>
              </div>
              <div className="text-end">
                AE {item?.ourprice}
                <br />
                {/* <select
                  className="form-select form-select-sm mt-2"
                  style={{ width: "80px" }}
                  defaultValue={`Qty: ${qty}`}
                >
                  {[...Array(10)].map((_, i) => (
                    <option key={i}>Qty: {i + 1}</option>
                  ))}
                </select> */}
              </div>
            </div>
            ))
          }
          {/* {[9, 3, 1].map((qty, idx) => (
            <div key={idx} className="d-flex align-items-center border-bottom py-3">
              <img
                src="https://via.placeholder.com/60"
                alt="Product"
                className="me-3"
              />
              <div className="flex-grow-1">
                <strong>#8786867 High Quality Italian Oven</strong>
                <br />
                <small>
                  Fully Smooth Steel Surface
                  <br />
                  Origin: Italy
                </small>
                <div className="mt-2">
                  <button className="btn btn-danger btn-sm me-2">Remove</button>
                  <button className="btn btn-warning btn-sm text-white">
                    Add to wishlist
                  </button>
                </div>
              </div>
              <div className="text-end">
                AED78.99
                <br />
                <select
                  className="form-select form-select-sm mt-2"
                  style={{ width: "80px" }}
                  defaultValue={`Qty: ${qty}`}
                >
                  {[...Array(10)].map((_, i) => (
                    <option key={i}>Qty: {i + 1}</option>
                  ))}
                </select>
              </div>
            </div>
          ))} */}

         {totalprice ? <div className="text-end mt-3">
            <ClearCartModal loading={Loading}  setremove={setRemove}/>
          </div> : <div>No Items In Cart</div> }
          <div className="mt-3">
            <button className="btn btn-danger">&lt; <Link to='/Shop' className="btn btn-danger">Back to shop</Link> </button>
          </div>
        </div></div>

        {/* Summary Section */}
       {totalprice ? <div className="col-lg-4 mt-4 mt-lg-0">
          <div className="bg-light p-4 rounded">
            <h6>Have a coupon?</h6>
            <div className="input-group mb-3">
              <input onChange={(e) => setCode(e.target.value)} type="text" className="form-control" placeholder="Add coupon" />
              <button onClick={ applyCode} className="btn btn-primary btn-danger">Apply</button>
            </div>
            <div className="bg-white p-3 border rounded">
              <p>
                Subtotal: <span className="float-end">AED {totalprice}</span>
              </p>
              {
                
                appliedcode?.map((item,index) => 
                  (
                  <span key={index}>
                  <p>
                   Appliedcode: <span className="float-end text-danger">{item?.Name}</span>
                  </p>
                  <p>
                   Discount: <span className="float-end text-danger">- AED {item?.discountAmount}</span>
                  </p>
                  </span>
                ))
              }
              <p>
                Tax: <span className="float-end text-success">+ AED {tax}</span>
              </p>
              <hr />
              <h5>
                Total: <span className="float-end">AED {totalprice}</span>
              </h5>
              <Link to='/orderform' state={{totalprice:totalprice}}><button className='btn btn-success w-100 mt-3' disabled={Loading}>Place Order </button></Link>

              {/* <button className="btn btn-success w-100 mt-3">Checkout</button> */}
              <div className="text-center mt-3">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Accepted_credit_card_logos.svg/2560px-Accepted_credit_card_logos.svg.png"
                  alt="Payment Methods"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </div> : <></>}
      </div>

      {/* Footer Info */}
      <div className="row text-center mt-5">
        <div className="col-md-4">
          <p>🔒 Secure payment</p>
          <small>Have you ever finally just</small>
        </div>
        <div className="col-md-4">
          <p>📞 Customer support</p>
          <small>Have you ever finally just</small>
        </div>
        <div className="col-md-4">
          <p>🚚 Free delivery</p>
          <small>Have you ever finally just</small>
        </div>
      </div>
    </div>
    </section>
    </main>
    


   
      
        {/* totalcartitem === 0  ? <div className='bg-danger' style={{height:'100vh',flexGrow:'1'}}>
       
        <div className='container'>
        <div className='row'>
          <div className='col-md-12 text-center text-white' style={{marginTop:'200px'}}>
          
          <strong><h2>Your Cart Is Empty Shop To Add Items In Cart</h2></strong>
          </div>
        
        </div> </div>
         </div> :
        
     <div className='bg-info' style={{height:'100vh',flexGrow:'1'}}>
      
        <div className='container'>
 
          <div className='row '>
            <div className='col-md-12'>
            
             <div className='mt-4 mb-3'>
             {Loading ? <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <Loadersspinners /> </div>  : <h2>Your Cart</h2>  }  
             </div>
            
            <div>
            
        <Table striped bordered hover>
      <thead className='text-center'>
        <tr>
          <th>No</th>
          <th>Item Name</th>
          <th>Category</th>
          <th>Price</th>
          <th>Actions</th>
        </tr>
      </thead>
   

      <tbody className='text-center'>
     
      {
       productsarray.map((item,index)=>(
             <tr key={index} >
               <td>{index + 1}</td>
               <td>{item.name}</td>
               <td>{item.description}</td>
               <td>$.{item.price}</td>
               <td> <Modal itemid={item._id} setremove={setRemove} /></td>
          </tr> 
        ))
      }  
      </tbody> 
    </Table>

    
          </div>

            </div>
          </div>
         

          <div className='row' style={{display:'flex',justifyContent:'space-around'}}>
            <div className='col-md-6 text-center'>
            <h4><small style={{fontWeight:'100'}}>Total Item </small><span style={{fontSize:'40px'}}>{totallen}</span></h4> 
            </div>
            <div className='col-md-6 text-center'>
            <h4 style={{}}><small style={{fontWeight:'100'}}>Total Price </small><span style={{fontSize:'40px'}}>$. {totalprice}</span></h4>    
            </div>
          </div>

          <div className='row' style={{marginTop:'12px',marginBottom:'12px'}}>
          
          
          <div className='col-md-6 text-center'>
          <ClearCartModal loading={Loading}  setremove={setRemove}/> 
          </div>
          <div className='col-md-6 text-center'>
          <Link to='/orderform' state={{totalprice:totalprice}}><Button className='bg-warning' disabled={Loading}>Place Order </Button></Link>
          </div>
          </div>
       
        </div>
        
        </div>
        
         */}

         <Tempfooter />
    </div>
   
    
  )
}

export default Cart